import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-kiosk-homepage',
  templateUrl: './kiosk-homepage.component.html',
  styleUrls: ['./kiosk-homepage.component.scss']
})
export class KioskHomepageComponent implements OnInit {

  constructor() { }

  //data service içerisinde rData değişkeni var. Bu değişkenin içerisindeki restaurants

  //D:\Repositories\guest-service-cvk\src\app\pages\components\menu-section\menu-section.component.html örneğindeki gibi bir html yapısı oluşturulacak.
  
  ngOnInit() {
  }

}
